import { useContext } from "react";

import { MaintenanceModeProvider } from "./maintenance-mode-component.context.lib";
import { MaintenanceModeContext } from "./maintenance-mode.context.lib";

const useMaintenanceMode = () => useContext(MaintenanceModeContext);

export default MaintenanceModeProvider;
export { useMaintenanceMode };
